import { api } from '~/services/api';

export const getDistrictById = id => api.get(`/districts/${id}`);
